import { DeclineReason } from 'ng2-app/models/dto/decline-reason.model';

export class GetOfferOptions {
	static readonly type = '[OfferOption] GetOfferOptions';
	constructor(public borrowerId: number) {}
}

export class CreateOfferOption {
	static readonly type = '[OfferOption] CreateOfferOption';
	constructor(public dealId: number, public offerOptionData: object) {}
}

export class UpdateOfferOptionTerms {
	static readonly type = '[OfferOption] UpdateOfferOptionTerms';
	constructor(public dealId: number, public offerOptionId: number, public termSetData: object) {}
}

export class DeleteOfferOption {
	static readonly type = '[OfferOption] DeleteOfferOption';
	constructor(public dealId: number, public offerOptionId: number) {}
}

export class PatchOfferOptionStatus {
	static readonly type = '[OfferOption] PatchOfferOptionStatus';
	constructor(public dealId: number, public offerOptionId: number, public status: string, public waitOnResponse = false) {}
}

export class BuildOfferOptionsRelationships {
	static readonly type = '[OfferOption] BuildOfferOptionsRelationships';
	constructor(public borrowerId: number) {}
}

export class AttachValuePropsToOption {
  static readonly type = '[OfferOption] AttachValuePropsToOption';
  constructor(public offerOptionId: number, public valuePropositionIds: number[]) {}
}

export class AttachDeclineReasonsToOption {
  static readonly type = '[OfferOption] AttachDeclineReasonsToOption';
  constructor(public offerOptionId: number, public declineReasons: Pick<DeclineReason, 'id' | 'comment'>[]) {}
}

export class RecommendOfferOption {
  static readonly type = '[OfferOption] RecommendOfferOption';
  constructor(
    public offerOptionId: number,
    public recommend: boolean,
  ) {}
}

export class ResetRecommendedFlagOfferOptions {
  static readonly type = '[OfferOption] ResetRecommendedFlagOfferOptions';
  constructor(
    public offerOptionIds: number[],
  ) {}
}
